var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeartLine = function SvgHeartLine(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "heart-line")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.415 4.545c-1.676-1.676-3.894-2.591-6.262-2.591s-4.593 0.923-6.268 2.598l-0.875 0.875-0.889-0.889c-1.676-1.676-3.908-2.605-6.275-2.605-2.361 0-4.586 0.923-6.255 2.591-1.676 1.676-2.598 3.901-2.591 6.268 0 2.368 0.929 4.586 2.605 6.262l12.74 12.74c0.176 0.176 0.414 0.271 0.644 0.271s0.468-0.088 0.644-0.265l12.767-12.72c1.676-1.676 2.598-3.901 2.598-6.268 0.007-2.368-0.909-4.593-2.585-6.268zM28.113 15.786l-12.123 12.075-12.096-12.096c-1.33-1.33-2.062-3.094-2.062-4.973s0.726-3.643 2.056-4.966c1.323-1.323 3.087-2.056 4.959-2.056 1.879 0 3.65 0.733 4.979 2.062l1.533 1.533c0.36 0.36 0.936 0.36 1.296 0l1.52-1.52c1.33-1.33 3.1-2.062 4.973-2.062s3.636 0.733 4.966 2.056c1.33 1.33 2.056 3.094 2.056 4.973 0.007 1.879-0.726 3.643-2.056 4.973z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-line.f9d9feb9.svg";
export { ForwardRef as ReactComponent };